<div class="tab-pane" role="tabpanel" id="caractproy">
    <fieldset id="agregar_caractproy" class="">
        <div class="step_section">
            <h4 class="form-signin-heading"><strong>CARACTERISTICAS DEL PROYECTO </strong><span
                    *ngIf="n_form == '1.1'"><strong> (Para proyectos de edificación)</strong></span></h4>
            <hr>
            <div class="row" id="row">

                <div class="col-md-12" id="content">
                    <div class="alert alert-danger" role="alert" id="tp_find_alert" name="tp_find_alert" hidden>
                        <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i>
                        <span id="tp_dir_message"></span>
                    </div>
                    <div class="form-horizontal">
                        <form [formGroup]="form">
                            <div class="form-group" align="left">
                                <div class="col-md-1">
                                    <label for="dproy" style="padding-bottom: 20px; padding-top: 15px;">Destino
                                        Principal</label>
                                </div>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Destino" id="destino" name="destino"
                                            formControlName="destino">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2">
                                    <label class="control-label" for="supertotal"
                                        style="padding-bottom: 20px; padding-top: 15px;">Superficie Total
                                        Proyectada</label>
                                </div>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Superficie Total" id="supertotal" name="supertotal"
                                            formControlName="supertotal">
                                            <span matSuffix>m²</span>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2">
                                    <label for="dproy" style="padding-bottom: 20px; padding-top: 15px;">Nro de pisos
                                        sobre terreno</label>
                                </div>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Nro de pisos" id="npisos" name="npisos"
                                            formControlName="npisos">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-group" align="left">
                                <div class="col-md-4">
                                    <label for="dproy">Ha Habido cambios el en Proyecto Aprobado (Art. 5.2.8.
                                        OGUC)</label>
                                </div>
                                <div class="col-sm-3">
                                    <mat-radio-group formControlName="modradio">
                                        <mat-radio-button style="padding-right: 20px" name="modradio" value="SI">SI
                                        </mat-radio-button>
                                        <mat-radio-button style="padding-right: 20px" name="modradio" value="NO">NO
                                        </mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                            <div style="padding-top: 10px"></div>
                            <div class="form-group" align="left">
                                <div class="col-md-4">
                                    <label for="dproy">Edificio de Uso P&uacute;blico</label>
                                </div>
                                <div class="col-sm-3">
                                    <mat-radio-group formControlName="usoradio">
                                        <mat-radio-button style="padding-right: 20px" name="usoradio" value="SI">SI
                                        </mat-radio-button>
                                        <mat-radio-button style="padding-right: 20px" name="usoradio" value="NO">NO
                                        </mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                            <div class="col-md-4"></div>
                            <div class="col-md-1" style="padding-top: 30px">
                                <button mat-raised-button color="primary" style="padding-top: 5px"
                                    id="ingreso_cproyecto" (click)="add_caracteristica_proyecto()">
                                    Agregar Caracteristicas Proyecto
                                    <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="datatable_antecedentes">
                <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'"
                    [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                    <ngx-datatable-column>
                        <ng-template ngx-datatable-header-template>
                            <span>DESTINO</span>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.destino}}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column>
                        <ng-template ngx-datatable-header-template>
                            <span>SUPERFICIE TOTAL</span>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.supertotal}}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column>
                        <ng-template ngx-datatable-header-template>
                            <span>CAMBIO EN PROYECTO APROB</span>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.modradio}}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column>
                        <ng-template ngx-datatable-header-template>
                            <span>EDIF. USO PUB.</span>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.usoradio}}
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column>
                        <ng-template ngx-datatable-header-template>
                            <span>OPCIONES</span>
                        </ng-template>
                        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                            <span (click)="get_caracteristica_proyecto(rowIndex)" style="padding-right: 5px;"><i
                                    class="glyphicon glyphicon-pencil"></i></span>
                            <span (click)="delete_caracteristica_proyecto(rowIndex)"><i
                                    class="glyphicon glyphicon-trash"></i></span>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>
        </div>
    </fieldset>
    <!--Modal-->
    <ng-template #openModal>
        <h2 mat-dialog-title>informaci&oacute;n Caracacterisca Proyecto</h2>
        <mat-dialog-content>
            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Caracteristica Proyecto</strong>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="tipo">Destino</label>
                    <div class="col-md-6">
                        <input id="numcaract" name="numcaract" type="hidden" placeholder="numcaract"
                            class="form-control input-md" [(ngModel)]="temp_cproy.numcaract">
                        <input id="destino" name="destino" type="text" placeholder="destino"
                            [(ngModel)]="temp_cproy.destino" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="supertotal">Superficie Total</label>
                    <div class="col-md-6">
                        <input id="supertotal" name="supertotal" type="text" placeholder="Superficie Total"
                            [(ngModel)]="temp_cproy.supertotal" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="npisos">Nro de pisos</label>
                    <div class="col-md-6">
                        <input id="npisos" name="npisos" type="text" placeholder="Nro de pisos"
                            [(ngModel)]="temp_cproy.npisos" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="modradio">Ha Habido cambios el en Proyecto Aprobado (Art.
                        5.2.8. OGUC)</label>
                    <div class="col-sm-1">
                        <label class="radio-inline"><input id="modradio" ng-control="modradio" name="modradio"
                                type="radio" value="SI" [(ngModel)]="temp_cproy.modradio" />SI</label>
                    </div>
                    <div class="col-sm-1">
                        <label class="radio-inline"><input id="modradio" ng-control="modradio" name="modradio"
                                type="radio" value="NO" [(ngModel)]="temp_cproy.modradio" />NO</label>
                    </div>
                    <div class="col-md-6"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="usoradio">Edificio de Uso P&uacute;blico</label>
                    <div class="col-sm-1">
                        <label class="radio-inline"><input id="usoradio" name="usoradio" ng-control="usoradio"
                                type="radio" value="SI" [(ngModel)]="temp_cproy.usoradio" />SI</label>
                    </div>
                    <div class="col-sm-1">
                        <label class="radio-inline"><input id="usoradio" name="usoradio" ng-control="usoradio"
                                type="radio" value="NO" [(ngModel)]="temp_cproy.usoradio" />NO</label>
                    </div>
                    <div class="col-md-6"></div>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_cproyecto" data-dismiss="modal"
                (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id="ingreso_cproyecto"
                (click)="save_caracteristica_proyecto() ">Ingresar Caracteristica Proyecto <i class="fa fa-user-o "
                    aria-hidden="true "></i></button>

        </mat-dialog-actions>
    </ng-template>
</div>

<ng-template #openModalNODATA>
    <h2 mat-dialog-title>Ingrese datos</h2>
    <mat-dialog-content>
        No ingreso ninguna caracteristica.
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal"
            (click)="cleanData()">Aceptar</button>
    </mat-dialog-actions>
</ng-template>
<div class="separator"></div>